import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'section-title';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'h1', { class: ['section-title', ctx.data.staticClass] }, [
                ctx.slots().default
            ]
        )
    }
}